import { Outlet } from "react-router-dom";
import Footer from "./components/footer";
import Header from "./components/header.jsx"

export default function Layout() {
  return (
    <main>
      <Header />
      <Outlet />
      <Footer />
    </main>
  );
}